import { createSelector } from '@ngrx/store';
import { selectFeatureStore } from './generic.selectors';

export const selectCallCentreStatus = createSelector(
  selectFeatureStore,
  ({ callCentreStatus }) => callCentreStatus,
);

export const selectIsCallCentreStatusNotNow = createSelector(
  selectCallCentreStatus,
  (callCentreStatus) => callCentreStatus === 'NotNow',
);
